'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LearnHero from './components/LearnHero';
import LearnDiscover from './components/LearnDiscover';
import LearnLiveClasses from './components/LearnLiveClasses';
import LearnProgress from './components/LearnProgress';
import LearnTutors from './components/LearnTutors';
import LearnForParents from './components/LearnForParents';
import LearnCTA from './components/LearnCTA';

export default function WislyLearnPage() {
    return (
        <main className="min-h-screen overflow-x-hidden" style={{ background: '#FAFAFA', color: '#0D0D0D' }}>
            <Header />
            <LearnHero />
            <LearnDiscover />
            <LearnLiveClasses />
            <LearnProgress />
            <LearnTutors />
            <LearnForParents />
            <LearnCTA />
            <Footer />
        </main>
    );
}
